import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import ROUTES from "shared/routes";

export const useMonitorRoutes = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      localStorage.removeItem("pathname");
    } else if (
      location.pathname === ROUTES.LOGIN ||
      location.pathname === ROUTES.CODE ||
      location.pathname === ROUTES.COMPANIES_BIND ||
      location.pathname === ROUTES.REGISTRATION ||
      location.pathname === ROUTES.SIGN_PERSONAL_DATA ||
      location.pathname === ROUTES.IDENTITY_VERIFICATION ||
      location.pathname === ROUTES.IDENTITY_VERIFICATION_MAIN
    ) {
      // do nothing
    } else {
      localStorage.setItem("pathname", location.pathname + location.search);
    }
  }, [location]);
};
